import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import HomeVideo from './homeVideo';
import ScrollMagicFn from '@/utils/ScrollMagic';

const PageConPc = dynamic(() => import('@/components/productSmart/smarthomepanel/indexDynamic'), {
    ssr: true,
});

export default function GsapC() {
    if (typeof window == 'undefined') {
        //return null;
    } else {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    return (
        <div className={`${css.gsapc} gsapc`}>
            <HomeVideo />
            <PageConPc />
        </div>
    );
}
